import { DocumentToSignHistory } from './../../../models/DocumentToSign/DocumentToSignHistory';
import { SignedDocumentsService } from './../../../core/services/signedDocuments.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { catchError, switchMap } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';

@Component({
  selector: 'app-check-signed-document',
  templateUrl: './check-signed-document.component.html',
  styleUrls: ['./check-signed-document.component.css'],
  standalone: false
})
export class CheckSignedDocumentComponent implements OnInit {

  public history: DocumentToSignHistory[];
  public errorMessage: string;
  constructor(private signedDocumentsService: SignedDocumentsService,
    private route: ActivatedRoute, ) {
    combineLatest([this.route.paramMap, this.route.fragment]).pipe(
      switchMap(([params, fragment]: [ParamMap, string]) => {
        this.history = null;
        this.errorMessage = null;
        const access = new URLSearchParams(fragment || '');
        return this.signedDocumentsService.getSignedDocumentHistory(params.get('documentToSignID'), access.has('access') ? access.get('access') : undefined).pipe(
          catchError(error => {
            this.errorMessage = typeof error === 'string' ? error : 'The document history could not be loaded. Please try again later.';
            return of(null);
          })
        );
      })
    ).subscribe(history => {
      this.history = history;
    });
  }

  ngOnInit() {
  }

}
